<template>
	<div>
		<div class="cm-list-paging pt-2 mb-2">
			<div class="list-paging-mobile mb-2 w-100">
				<div class="btn-group w-100">
					<button
						type="button"
						class="btn btn-white btn-arrow"
						@click="goToPage(prevPage)"
						title="Zeige vorherige Seite"
						:disabled="page === 1"
					>
						<i class="mdi mdi-chevron-left"></i> Vorherige
					</button>
					<button
						type="button"
						class="btn btn-white btn-arrow"
						@click="goToPage(nextPage)"
						:disabled="page >= maxPage"
						title="Zeige nächsten Seite"
					>
						Nächste <i class="mdi mdi-chevron-right"></i>
					</button>
				</div>
			</div>
			<div
				class="btn-group list-paging-desktop"
				role="group"
				aria-label="Seitennavigation"
			>
				<button
					type="button"
					class="btn btn-white btn-arrow"
					@click="goToPage(1)"
					:disabled="page === 1"
					title="Zeige erste Seite"
				>
					<i class="mdi mdi-page-first"></i>
				</button>
				<button
					type="button"
					class="btn btn-white btn-arrow"
					@click="goToPage(prevPage)"
					title="Zeige vorherige Seite"
					:disabled="page === 1"
				>
					<i class="mdi mdi-chevron-left"></i>
				</button>
				<button
					v-if="prevPrevPrevPage > 0"
					type="button"
					@click="goToPage(prevPrevPrevPage)"
					class="btn btn-white"
					:title="'Zeige Seite ' + prevPrevPrevPage"
				>
					{{ prevPrevPrevPage }}
				</button>
				<button
					v-if="prevPrevPage > 0"
					type="button"
					@click="goToPage(prevPrevPage)"
					class="btn btn-white"
					:title="'Zeige Seite ' + prevPrevPage"
				>
					{{ prevPrevPage }}
				</button>
				<button
					v-if="prevPage > 0"
					type="button"
					@click="goToPage(prevPage)"
					class="btn btn-white"
					:title="'Zeige Seite ' + prevPage"
				>
					{{ prevPage }}
				</button>
				<button type="button" class="btn btn-dark active">{{ page }}</button>
				<button
					v-if="nextPage <= maxPage"
					type="button"
					@click="goToPage(nextPage)"
					class="btn btn-white"
					:title="'Zeige Seite ' + nextPage"
				>
					{{ nextPage }}
				</button>
				<button
					v-if="nextNextPage <= maxPage"
					type="button"
					@click="goToPage(nextNextPage)"
					:title="'Zeige Seite ' + nextNextPage"
					class="btn btn-white"
				>
					{{ nextNextPage }}
				</button>
				<button
					v-if="nextNextNextPage <= maxPage"
					type="button"
					:title="'Zeige Seite ' + nextNextNextPage"
					@click="goToPage(nextNextNextPage)"
					class="btn btn-white"
				>
					{{ nextNextNextPage }}
				</button>
				<button
					type="button"
					class="btn btn-white btn-arrow"
					@click="goToPage(nextPage)"
					:disabled="page >= maxPage"
					title="Zeige nächsten Seite"
				>
					<i class="mdi mdi-chevron-right"></i>
				</button>
				<button
					type="button"
					class="btn btn-white btn-arrow"
					title="Zeige letzten Seite"
					@click="goToPage(maxPage)"
					:disabled="page >= maxPage"
				>
					<i class="mdi mdi-page-last"></i>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import store from '@/store'

export default {
	name: 'ListPaging',
	props: {
		page: Number,
		perPage: Number,
		countTotal: Number,
	},
	computed: {
		prevPrevPrevPage() {
			return this.page - 3
		},
		prevPrevPage() {
			return this.page - 2
		},
		prevPage() {
			return this.page - 1
		},
		nextPage() {
			return this.page + 1
		},
		nextNextPage() {
			return this.page + 2
		},
		nextNextNextPage() {
			return this.page + 3
		},
		maxPage() {
			return Math.ceil(this.countTotal / this.perPage)
		},
	},
	methods: {
		goToPage(page) {
			store.commit('setPage', page)
			this.$emit('go-to-page', page)
			window.scrollTo(0, 0)
		},
	},
}
</script>

<style scoped></style>
